import { useTranslation } from 'react-i18next';
import { cx } from '@twind/core';

import { FormItemButton } from '../types';

type Props = {
  item: FormItemButton;
  hasErrors: boolean;
  isValid: boolean;
  disabled: boolean;
  className?: string;
};

export function ContactFormButton({ item, hasErrors, isValid, disabled, className }: Props) {
  const { t } = useTranslation();
  return (
    <>
      <div className={cx('ostro-contact-form-button flex flex-col gap-3', className)}>
        <input
          type="hidden"
          name={item.ref_id}
          value="true"
        />
        {hasErrors ? (
          <div
            className="text-xs -mt-1 text-[#FF3323] text-center"
            aria-hidden="true"
          >
            {t('contact_form_has_errors')}
          </div>
        ) : null}
        <button
          type="submit"
          disabled={disabled}
          className={cx(
            isValid ? `faq-button-${item.button_style}` : 'faq-button-disabled',
            'transition disabled:opacity-50'
          )}
          aria-invalid={!isValid}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: item.button_text,
            }}
          />
        </button>
      </div>
      <div className="h-2 shrink-0" />
    </>
  );
}
